"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var react_1 = __importDefault(require("react"));
var PartnerSettings_module_css_1 = __importDefault(require("./PartnerSettings.module.css"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var PartnerSettingsFormItem = function (props) {
    var text = props.text, id = props.id, type = props.type, value = props.value, _a = props.readOnly, readOnly = _a === void 0 ? false : _a, _b = props.className, className = _b === void 0 ? PartnerSettings_module_css_1.default.inputField : _b, onChange = props.onChange;
    return (react_1.default.createElement("div", { className: PartnerSettings_module_css_1.default.inputContainer },
        react_1.default.createElement(Label_1.default, { htmlFor: id, className: PartnerSettings_module_css_1.default.label }, text),
        react_1.default.createElement("div", { className: PartnerSettings_module_css_1.default.inputFieldContainer },
            react_1.default.createElement("div", { className: "w-100" },
                react_1.default.createElement(q_play_components_1.Input, { style: { cursor: readOnly ? "default" : "auto" }, id: id, type: type, className: className, value: value, readOnly: readOnly, onChange: onChange, "data-cy": props.dataCy })))));
};
exports.default = PartnerSettingsFormItem;
